import { candleParser } from '../candleParser';

/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645477993687,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","candle":{"high":101.0,"low":99.0,"open":100.0,"close":100.0,"candleSymbol":"XYZ","candleStartTimeStamp":1641110640000,"duration":"1min"}},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"CANDLE_TRAIL","symbol":"XYZ"},
	"date": "2022-02-21T16:13:14.587-0500",
	"timestamp": "1645477994591"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 */
export function candleTrailParser(pluginTemplate) {
  const parsedObject = {
    candleDuration: null,
    timeUnit: null,
    candle: null,
  };
  if (pluginTemplate) {
    parsedObject.candleDuration = pluginTemplate.candleDuration;
    parsedObject.timeUnit = pluginTemplate.timeUnit;
    const candle = candleParser(pluginTemplate.candle);
    if (candle) {
      parsedObject.candle = candle;
    }
  }
  return parsedObject;
}
